// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AHdEm","bullet":"styles_bullet___b_U2","bulletActive":"styles_bulletActive__JqqGR","paginationContainer":"styles_paginationContainer__lC7ZX"};